import { observer } from 'mobx-react';
import { ButtonType, IButtonProps } from 'office-ui-fabric-react/lib/Button';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { lightable, lighted, LightningProps } from 'owa-lightning-v2';
import loc from 'owa-localize';
import * as React from 'react';
import {
    callout_addStorageAccount_body,
    callout_addStorageAccount_button,
    callout_addStorageAccount_title,
} from './AddStorageAccountCallout.locstring.json';

export interface AddStorageAccountCalloutProps extends LightningProps {
    target: () => HTMLElement;
}

@observer
@lightable
export class AddStorageAccountCallout extends React.Component<AddStorageAccountCalloutProps, {}> {
    render() {
        const gotItButtonProps: IButtonProps = {
            buttonType: ButtonType.primary,
            children: loc(callout_addStorageAccount_button),
            onClick: this.onClose,
        };

        return (
            <TeachingBubble
                calloutProps={{
                    beakWidth: 15,
                    directionalHint: DirectionalHint.rightCenter,
                    minPagePadding: 50,
                    gapSpace: 20,
                }}
                targetElement={this.props.target()}
                hasCloseIcon={true}
                onDismiss={this.onClose}
                hasSmallHeadline={true}
                headline={loc(callout_addStorageAccount_title)}
                primaryButtonProps={gotItButtonProps}>
                {loc(callout_addStorageAccount_body)}
            </TeachingBubble>
        );
    }

    private onClose = () => {
        lighted(this.props.lid);
    };
}
